<div class="flex h-full flex-col items-center justify-center">
  <div class="circle-size relative">
    <div class="absolute inset-0 flex flex-col items-center justify-center">
      <div class="z-10 text-xl font-bold text-white">{{ countdown }}s</div>
    </div>
    <div class="absolute inset-0 flex items-center justify-center rounded-full bg-transparent">
      <svg class="h-full w-full">
        <circle
          class="z-10 stroke-current text-white"
          [attr.stroke-dasharray]="circumference"
          [attr.stroke-dashoffset]="progressOffset"
          [attr.r]="radius"
          cx="50%"
          cy="50%"
        ></circle>
      </svg>
    </div>
  </div>
</div>
